import { FeatureFlag } from '../FeatureFlag';

export const hideFastMovingIdeasMenuInNewsAndEvents = new FeatureFlag({
    key: 'hide-fast-moving-ideas-menu-in-news-and-events',
    createdOn: '2025-05-02',
    defaultValue: true,
});
